module.exports = __webpack_public_path__ + "img/2.74278508.svg";